export { Template as EstatePlanningRecommendationQualificationFailedConfirmationStepTemplate } from './Template';
